<div class="emission-details-container p-4">
  <form [formGroup]="formGroup">
    <!-- Informations de l'émission -->
    <p-card header="Informations de l'émission" styleClass="mb-4">
      <div class="grid">
        <div class="col-12 md:col-6">
          <div class="field">
            <label for="region" class="block mb-2">Région/Pays *</label>
            <p-select
              id="region"
              formControlName="region"
              [options]="countries"
              optionLabel="name"
              optionValue="code"
              placeholder="Sélectionner un pays"
              [style]="{ width: '100%' }">
              <ng-template let-country pTemplate="selectedItem">
                <div class="flex align-items-center gap-2" *ngIf="country">
                  <img [src]="country.flagUrl" style="width: 20px" [alt]="country.name" />
                  <span>{{ country.name }}</span>
                </div>
              </ng-template>
              <ng-template let-country pTemplate="item">
                <div class="flex align-items-center gap-2">
                  <img [src]="country.flagUrl" style="width: 20px" [alt]="country.name" />
                  <span>{{ country.name }}</span>
                </div>
              </ng-template>
            </p-select>
            <small class="p-error" *ngIf="formGroup.get('region')?.invalid && formGroup.get('region')?.touched">
              Le pays est obligatoire
            </small>
          </div>
        </div>

        <div class="col-12 md:col-6">
          <div class="field">
            <label for="amount" class="block mb-2">Montant (FCFA) *</label>
            <p-inputNumber
              id="amount"
              formControlName="amount"
              mode="currency"
              currency="XOF"
              locale="fr-FR"
              [style]="{ width: '100%' }">
            </p-inputNumber>
            <small class="p-error" *ngIf="formGroup.get('amount')?.invalid && formGroup.get('amount')?.touched">
              Le montant est obligatoire
            </small>
          </div>
        </div>

        <div class="col-12 md:col-6">
          <div class="field">
            <label for="operationDate" class="block mb-2">Date d'opération *</label>
            <p-datepicker
              id="operationDate"
              formControlName="operationDate"
              dateFormat="dd/mm/yy"
              [showIcon]="true"
              [style]="{ width: '100%' }">
            </p-datepicker>
            <small class="p-error" *ngIf="formGroup.get('operationDate')?.invalid && formGroup.get('operationDate')?.touched">
              La date d'opération est obligatoire
            </small>
          </div>
        </div>

        <div class="col-12 md:col-6">
          <div class="field">
            <label for="valueDate" class="block mb-2">Date de valeur *</label>
            <p-datepicker
              id="valueDate"
              formControlName="valueDate"
              dateFormat="dd/mm/yy"
              [showIcon]="true"
              [style]="{ width: '100%' }">
            </p-datepicker>
            <small class="p-error" *ngIf="formGroup.get('valueDate')?.invalid && formGroup.get('valueDate')?.touched">
              La date de valeur est obligatoire
            </small>
          </div>
        </div>
      </div>
    </p-card>

    <!-- Liste des titres -->
    <p-card styleClass="mb-4">
      <ng-template pTemplate="header">
        <div class="flex justify-content-between align-items-center w-full p-3">
          <span class="text-xl font-semibold">Titres de l'émission</span>
          <p-button
            *ngIf="!isView"
            label="Ajouter un titre"
            icon="pi pi-plus"
            (onClick)="addTitre()"
            severity="success"
            size="small">
          </p-button>
        </div>
      </ng-template>

      <div formArrayName="titresDTO">
        <div *ngFor="let titreForm of titresFormArray.controls; let i = index" class="mb-4">
          <p-card [formGroupName]="i" styleClass="surface-50">
            <ng-template pTemplate="header">
              <div class="flex justify-content-between align-items-center w-full p-3">
                <span class="font-semibold">Titre {{ i + 1 }}</span>
                <p-button
                  *ngIf="!isView && titresFormArray.length > 1"
                  icon="pi pi-trash"
                  (onClick)="removeTitre(i)"
                  severity="danger"
                  [text]="true"
                  size="small">
                </p-button>
              </div>
            </ng-template>

            <div class="grid">
              <div class="col-12 md:col-6">
                <div class="field">
                  <label [for]="'isin-' + i" class="block mb-2">Code ISIN</label>
                  <input
                    [id]="'isin-' + i"
                    pInputText
                    formControlName="isin"
                    placeholder="Ex: XS1234567890"
                    class="w-full" />
                </div>
              </div>

              <div class="col-12 md:col-6">
                <div class="field">
                  <label [for]="'typeInstrument-' + i" class="block mb-2">Type d'instrument *</label>
                  <p-select
                    [id]="'typeInstrument-' + i"
                    formControlName="typeInstrument"
                    [options]="instrumentTypes"
                    optionLabel="label"
                    optionValue="value"
                    placeholder="Sélectionner un type"
                    [style]="{ width: '100%' }">
                  </p-select>
                  <small class="p-error" *ngIf="titreForm.get('typeInstrument')?.invalid && titreForm.get('typeInstrument')?.touched">
                    Le type d'instrument est obligatoire
                  </small>
                </div>
              </div>

              <div class="col-12 md:col-4">
                <div class="field">
                  <label [for]="'dueDate-' + i" class="block mb-2">Date d'échéance *</label>
                  <p-datepicker
                    [id]="'dueDate-' + i"
                    formControlName="dueDate"
                    dateFormat="dd/mm/yy"
                    [showIcon]="true"
                    [style]="{ width: '100%' }">
                  </p-datepicker>
                  <small class="p-error" *ngIf="titreForm.get('dueDate')?.invalid && titreForm.get('dueDate')?.touched">
                    La date d'échéance est obligatoire
                  </small>
                </div>
              </div>

              <div class="col-12 md:col-4">
                <div class="field">
                  <label [for]="'rate-' + i" class="block mb-2">Taux d'intérêt (%) *</label>
                  <p-inputNumber
                    [id]="'rate-' + i"
                    formControlName="rate"
                    mode="decimal"
                    [minFractionDigits]="2"
                    [maxFractionDigits]="2"
                    suffix="%"
                    [style]="{ width: '100%' }">
                  </p-inputNumber>
                  <small class="p-error" *ngIf="titreForm.get('rate')?.invalid && titreForm.get('rate')?.touched">
                    Le taux est obligatoire
                  </small>
                </div>
              </div>

              <div class="col-12 md:col-4">
                <div class="field">
                  <label [for]="'unitNominalValue-' + i" class="block mb-2">Valeur nominale unitaire *</label>
                  <p-inputNumber
                    [id]="'unitNominalValue-' + i"
                    formControlName="unitNominalValue"
                    mode="currency"
                    currency="XOF"
                    locale="fr-FR"
                    [style]="{ width: '100%' }">
                  </p-inputNumber>
                  <small class="p-error" *ngIf="titreForm.get('unitNominalValue')?.invalid && titreForm.get('unitNominalValue')?.touched">
                    La valeur nominale est obligatoire
                  </small>
                </div>
              </div>
            </div>
          </p-card>
        </div>

        <div *ngIf="titresFormArray.length === 0" class="text-center p-4 surface-100 border-round">
          <i class="pi pi-inbox text-4xl text-400 mb-3"></i>
          <p class="text-600">Aucun titre ajouté. Cliquez sur "Ajouter un titre" pour commencer.</p>
        </div>
      </div>
    </p-card>

    <!-- Boutons d'action -->
    <div class="flex justify-content-end gap-2">
      <p-button
        label="Annuler"
        icon="pi pi-times"
        (onClick)="cancel()"
        severity="secondary"
        [outlined]="true">
      </p-button>
      <p-button
        *ngIf="!isView"
        label="Enregistrer"
        icon="pi pi-check"
        (onClick)="save()"
        severity="primary">
      </p-button>
    </div>
  </form>
</div>
